import { AuthService } from './../../shared/models/auth.service';
import { TranslateService } from './../../shared/translate/translate.service';
import { FlatPickrModel } from './../../plugins/flatpickr/flatpickr.model';
import { Router } from '@angular/router';
import { IKeyValueInterface, WeGoConfig, DataListModel } from './../../shared/config';
import { BookingService } from './../../booking/models/booking.service';
import { VehicleService } from './../../vehicle/models/vehicle.service';
import { VehicleModel } from './../../vehicle/models/vehicle.model';
import { SharedVehicleGroupService } from './../../sharedvehiclegroup/models/sharedvehiclegroup.service';
import { SharedVehicleGroupModel } from './../../sharedvehiclegroup/models/sharedvehiclegroup.model';
import { SchedulerBookingModel } from './../../booking/models/schedular-booking.model';
import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { DropdownModel } from '../../report/models/report-filter.model';

const $ = require("jquery");
const moment = require("moment");
const fullCalendar = require("fullcalendar");
//declare var fullCalendar: any;

@Component({
  selector: 'wego-scheduler-booking-driver',
  template: require('../views/scheduler-booking-driver.component.html'),
  styles: [`
          .box.box-default{
            border: 1px solid #ddd;
            border-top: 3px solid #2BA2AA;
          }
          .box-body{
            padding: 0px 10px 10px;
          }
          `
  ],
})
export class SchedularBookingDriverComponent implements OnInit {
  public dateFormat: string = WeGoConfig.FLATPICKR_DATE_TIME_FORMAT;
  bookingList: any;
  flatPickrConfigFrom: FlatPickrModel;
  flatPickrConfigTo: FlatPickrModel;
  model: SchedulerBookingModel;
  sharedVehicleGroupList: DropdownModel[];
  VehicleList: DropdownModel[];
  errorMessage: string;
  sharedVehicleGroupHashID: string;
  DataListModel: DataListModel;
  errorModel: IKeyValueInterface[];
  apiErrorMsg: string;
  isSharedVehicleGroupVisible = true;
  @ViewChild('bookingInfoModel') public bookingInfoModel: any;

  constructor(private authService: AuthService,
    private bookigService: BookingService,
    private sharedVehicleGroupService: SharedVehicleGroupService,
    private vehicleService: VehicleService,
    private router: Router,
    private translate: TranslateService
  ) {

  }

  ngOnInit() {
    this.flatPickrConfigFrom = this.SetDefaultFlatPickrConfig();
    this.flatPickrConfigTo = this.SetDefaultFlatPickrConfig();

    this.model = new SchedulerBookingModel();
    this.model.startDateTime = moment().utc().format('DD-MM-YYYY HH:mm');
    this.model.endDateTime = moment().utc().add(1, 'M').format('DD-MM-YYYY HH:mm');


    this.DataListModel = new DataListModel();

    this.GetSharedVehicleGroupList();
    this.GetVehicleList();
    //this.GetScheduledBookingList();
    let currentLang = this.translate.currentLang;

    let LblWeekdays: any = this.translate.instant('LblWeekdays');
    let LblMonths: any = this.translate.instant('LblMonths');
    let LblButtonText: any = this.translate.instant('LblButtonText');

    $('#calendar').fullCalendar({
      header: {
        left: 'prev,today,next ',
        center: 'title',
        right: 'month,agendaWeek,agendaDay'
      },
      displayEventEnd: {
        month: true,
        basicWeek: true,
        default: true
      },
      eventRender: (event: any, element: any) => {
        element.attr('href', 'javascript:void(0);');
        element.click(() => {
          this.bookingInfoModel.bookingInfo = event;
          this.bookingInfoModel.show();
        });
      },
      viewRender:  (view: any, element: any)=>{
        if (this.model) {
          this.model.startDateTime = view.start.format('DD-MM-YYYY HH:mm');
          this.model.endDateTime = view.end.format('DD-MM-YYYY HH:mm');          
          this.OnSearchVehicleBooking();
        }
      },      
      //locale: currentLang,
      buttonText: LblButtonText,
      monthNames: LblMonths.longhand,
      monthNamesShort: LblMonths.shorthand,
      dayNames: LblWeekdays.longhand,
      dayNamesShort: LblWeekdays.shorthand,
      navLinks: true, // can click day/week names to navigate views
      editable: false,
      eventLimit: true, // allow "more" link when too many events
    });
  }

  private SetDefaultFlatPickrConfig() {
    let flatPickrConfig = new FlatPickrModel();
    flatPickrConfig.enableTime = true;
    flatPickrConfig.time_24hr = true;
    //flatPickrConfig.enableSeconds = true;
    flatPickrConfig.dateFormat = this.dateFormat;
    flatPickrConfig.minuteIncrement = 1;
    return flatPickrConfig;
  }

  public GetSharedVehicleGroupList() {
    this.sharedVehicleGroupService.GetSharedVehicleDropdownList()
      .subscribe(
      res => {
        this.sharedVehicleGroupList = res.data;
        if (this.sharedVehicleGroupList.length > 0) {
          this.model.sharedVehicleGroupHashId = this.model.sharedVehicleGroupHashId || this.sharedVehicleGroupList.length > 1 ? '' : this.sharedVehicleGroupList[0].keyHash;
          if (this.sharedVehicleGroupList.length > 1) {
            this.isSharedVehicleGroupVisible = true;
          }
          else {
            this.isSharedVehicleGroupVisible = false;
            this.GetVehicleList();
          }
        }
        else {
          this.isSharedVehicleGroupVisible = false;
        }
      },
      error => {
        this.errorMessage = <any>error;
      }
      );
  }

  public GetVehicleList() {
    this.vehicleService.GetVehicleDropdownListBySVGID(this.model.sharedVehicleGroupHashId)
      .subscribe(
      res => {
        this.VehicleList = res.data;
        this.model.vehicleHashId = this.model.vehicleHashId || this.VehicleList.length > 0 ? '' : '';
      },
      error => {
        this.errorMessage = <any>error;
      }
      );
  }

  onChangeSelectedSVG(selectedField: any) {
    this.model.sharedVehicleGroupHashId = selectedField;
    this.GetVehicleList();
    console.log(this.model.sharedVehicleGroupHashId);
  }

  onChangeSelectedVehicle(selectedField: any) {
    this.model.vehicleHashId = selectedField;
    console.log(this.model.vehicleHashId);
  }

  OnSearchVehicleBooking() {
    console.log(this.model);
    this.GetScheduledBookingList();
  }

  public GetScheduledBookingList() {
    this.bookigService.GetScheduledBookingList(this.model)
      .subscribe(
      (res: any) => {
        if (!res.data) {
          this.errorModel = res.error;
        }
        else {
          this.bookingList = res.data;
          $('#calendar').fullCalendar('removeEvents');
          //$('#calendar').fullCalendar('refetchEvents');
          $('#calendar').fullCalendar('addEventSource', { events: this.bookingList })
        }
      },
      (error: any) => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
      }
      );
  }
}





// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/booking-driver/components/scheduler-booking-driver.component.ts